<nb-card>
  <nb-card-header>
    <div class="logo-container">
      <a href="#"><img width="" alt="log" src="../../../../assets/images/logo-alternative.svg" href="#"></a>
    </div>
  </nb-card-header>
  <nb-card-body>
    <h5 id="title" class="title">Esqueci a senha</h5>
    <p class="sub-title">Digite seu endereço de e-mail e enviaremos um link para redefinir sua senha.</p>

    <nb-alert *ngIf="errors?.length" outline="danger" role="alert">
      <ul class="alert-message-list">
        <li *ngFor="let error of errors" class="alert-message">{{ error }}</li>
      </ul>
    </nb-alert>

    <nb-alert *ngIf="messages?.length" outline="success" role="alert">
      <ul class="alert-message-list">
        <li *ngFor="let message of messages" class="alert-message">{{ message }}</li>
      </ul>
    </nb-alert>

    <form (ngSubmit)="requestPass()" #requestPassForm="ngForm" aria-labelledby="title">
      <div class="form-control-group">
        <label class="label" for="input-email">Digite seu endereço de email:</label>
        <input nbInput [(ngModel)]="user.email" #email="ngModel" id="input-email" name="email" pattern=".+@.+\..+"
          placeholder="Email" autofocus fullWidth fieldSize="large"
          [status]="email.dirty ? (email.invalid  ? 'danger' : 'success') : 'basic'"
          [required]="getConfigValue('forms.validation.email.required')"
          [attr.aria-invalid]="email.invalid && email.touched ? true : null">
        <ng-container *ngIf="email.invalid && email.touched">
          <p class="caption status-danger" *ngIf="email.errors?.required">
            Campo obrigatório!
          </p>
          <p class="caption status-danger" *ngIf="email.errors?.pattern">
            Email inválido!
          </p>
        </ng-container>
      </div>
      <button nbButton fullWidth status="primary" size="large" [disabled]="submitted || !requestPassForm.valid"
        [class.btn-pulse]="submitted">
        Solicitar nova senha
      </button>
    </form>
  </nb-card-body>